import React from 'react';
import { FiFolder, FiFile } from 'react-icons/fi';
import { formatFileName } from '../utilities/formatFileName';
import { useHistoriskFilter } from '../contexts/HistoriskFilterContext';

const FileList = ({ files, onFileSelect, onFolderSelect, loading, folderName, isSearchResult }) => {
  const { filterFiles, showHistorisk, toggleShowHistorisk } = useHistoriskFilter();
  
  const filteredFiles = filterFiles(files);

  const handleItemClick = (item) => {
    if (item.ItemType === 'Folder') {
      // Handle folder click
      onFolderSelect(item.Id, item.FileUrl, item.Name);
    } else {
      // Handle file click
      onFileSelect(item);
    }
  };
  
  return (
    <div className="flex-1 p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-gray-800">
          {isSearchResult ? 'Søgeresultat' : (folderName || 'Filer')}
        </h2>
        
        {/* Filter checkbox */}
        <div className="flex items-center">
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={showHistorisk}
              onChange={toggleShowHistorisk}
              className="w-4 h-4 bg-gray-100 border-gray-300 rounded focus:ring-2 custom-checkbox"
              style={{
                '--tw-ring-color': 'rgba(238, 123, 25, 0.5)'
              }}
            />
            <span className="text-sm text-gray-700">Vis historiske filer</span>
          </label>
        </div>
      </div>
      {loading ? (
        <p className="text-gray-500">Henter indhold...</p>
      ) : filteredFiles.length === 0 ? (
        <p className="text-gray-500">Der findes ingen filer i denne folder.</p>
      ) : (
        <ul>
          {filteredFiles.map((item) => (
            <li
              key={item.Id}
              className="py-2 border-b border-gray-200 last:border-0 cursor-pointer hover:bg-gray-50"
              onClick={() => handleItemClick(item)}
            >
              <div className="flex items-center gap-2">
                {item.ItemType === 'Folder' ? (
                  <FiFolder className="text-yellow-500 w-5 h-5 flex-shrink-0" />
                ) : (
                  <FiFile className="text-gray-500 w-5 h-5 flex-shrink-0" />
                )}
                <div className="flex flex-col items-start">
                  <span>{formatFileName(item.Name)}</span>
                  {/* Show badges for files (ItemType === 'File') or items without ItemType (assume they're files from search) */}
                  {(item.ItemType === 'File' || !item.ItemType) && (
                    <>
                      {item.Historisk === "False" || item.Historisk === "0" ? (
                        <span
                          className="inline-block rounded-full px-3 py-1 text-xs font-semibold text-white mt-1"
                          style={{ backgroundColor: 'green' }}
                        >
                          GÆLDENDE
                        </span>
                      ) : item.Historisk === "True" || item.Historisk === "1" ? (
                        <span
                          className="inline-block rounded-full px-3 py-1 text-xs font-semibold text-white mt-1"
                          style={{ backgroundColor: 'red' }}
                        >
                          HISTORISK
                        </span>
                      ) : null}
                    </>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FileList;